import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";

const { locale } = await useLocale("validation");

export default {
  code: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
};
